import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function timeFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (
      ![
        // Examples: 10:30, 9:00 //
        /^(0?\d|1\d|2[0-3]):[0-5]\d$/,
        // Examples: 09:30 am, 9:30 AM //
        /^(1[0-2]|0?[1-9]):([0-5]\d) ?([ap]m)$/i,
      ].some((regex) => regex.test(control.value))
    ) {
      return {
        invalidTimeFormat: true,
      };
    }

    return null;
  };
}
